// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-list-items {
  margin: 0;
  padding: 0;
}
.sidebar-list-item {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
}
.sidebar-list-icon {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.user-dropdown {
  width: 200px !important;
}
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: red;
  width: 100%;
}
.sidebar-scroll {
  height: calc(90vh);
  overflow: auto;
  width: 250px;
}
.collapse {
  margin-left: 50px;
  padding: 0px;
}
.setup {
  margin-left: 0px;
}
.setup:hover {
  color: #2a8981;
  cursor: pointer;
}
.adminActivities {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
}
.hide {
  display: none !important;
}
.sidebar-icon-only .sidebar-list-items {
  width: 50px;
}
.sidebar-icon-only .link-text,
.sidebar-icon-only .adminActivities {
  display: none;
}
.sidebar-icon-only .sidebar-scroll {
  width: 50px;
}
.sidebar-icon-only .collapse {
  margin-left: 0px;
}
.text-active {
  color: #2a8981 !important;
}
.zindex99 {
  z-index: 99 !important;
}
.right-side {
  transform: rotateY(180deg);
}

.left-side {
  transform: rotateY(0deg);
}
.nav-item {
  font-style: normal;
  font-size: 15px;
  color: black !important;
  font-family: Poppins;
}

/* styles.css */
.sidebar-list-items {
  margin: 0;
  padding: 0;
}

.sidebar-list-item {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
}

.sidebar-list-item:hover {
  background-color: #f0f0f0; /* Update with your preferred hover color */
  border-radius: 6px 0px 0px 6px; /* Update with your preferred color */
}

.sidebar-list-item.selected {
  background-color: rgb(0, 123, 255) !important;
  color: white !important;
  border-radius: 6px 0px 0px 6px; /* Update with your preferred color */
}

.sidebar-list-item .link-text {
  color: black;
}

.sidebar-list-item.selected .link-text {
  color: #2a8981; /* Update with your preferred selected text color */
}

/* Add other styles as needed */
/* Sidebar styling */
.sidebar-open {
  transform: translateX(0);
}

.sidebar-closed {
  transform: translateX(-100%);
}

/* Toggle button styling */
.menu-icon-container_v3 {
  position: fixed;
  top: 15px;
  left: 15px;
  z-index: 100;
}

/* Styling for selected sidebar item */
.sidebar-list-item.selected {
  background-color: #007bff;
  color: white;
}

/* Sidebar item hover effect */
.sidebar-list-item:hover {
  background-color: #f0f0f0;
}
.nav-item {
  color: black !important; /* Ensure text color is always black */
}

/* Media query for small screens */
@media (max-width: 844px) {
  .icon {
    position: absolute;
    top: 5.2rem;
  }
  .navbar {
    background: #000 !important;
  }
  .sidebar {
    width: 75%;
  }
}

@media (max-width: 844px) {
  .sidebar {
    display: none;
  }

  .sidebar.open {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 220px;
    height: auto; /* Adjust height for dropdown */
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    transform: translateY(
      -100%
    ); /* Initially hide the sidebar above the viewport */
    transition: transform 0.3s ease;
    z-index: 1000;
    transform: translateY(0); /* Slide the sidebar down into view */
  }

  .menu-icon-container {
    display: flex;
    justify-content: flex-end;
    padding: px;
    margin-left: -40px;
    margin-top: 10px;
  }

  .menu-icon-container .btn {
    border: none;
    background-color: transparent;
  }

  .sidebar-open {
    background-color: #f8f9fa; /* Light background for visibility */
    border-right: 1px solid #ddd; /* Add a border for better separation */
  }

  .sidebar-closed {
    background-color: #f8f9fa; /* Match open state background */
  }

  .sidebar-list-item {
    font-size: 16px;
    color: #333; /* Text color for visibility */
  }

  .sidebar-list-item.selected {
    background-color: #007bff; /* Highlight selected item */
    color: white; /* Ensure selected text is visible */
  }

  .nav_link {
    color: inherit; /* Ensure link text uses parent's color */
  }
}

/* Hide menu icon on larger screens */
@media (min-width: 845px) {
  .menu-icon-container {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SidebarV3/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;;EAEE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,2CAA2C;EACtE,8BAA8B,EAAE,qCAAqC;AACvE;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;EACvB,8BAA8B,EAAE,qCAAqC;AACvE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,mDAAmD;AACrE;;AAEA,+BAA+B;AAC/B,oBAAoB;AACpB;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB,EAAE,sCAAsC;AACjE;;AAEA,kCAAkC;AAClC;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,YAAY,EAAE,+BAA+B;IAC7C,gBAAgB;IAChB,uCAAuC;IACvC;;KAEC,EAAE,kDAAkD;IACrD,+BAA+B;IAC/B,aAAa;IACb,wBAAwB,EAAE,qCAAqC;EACjE;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB,EAAE,oCAAoC;IAC/D,4BAA4B,EAAE,uCAAuC;EACvE;;EAEA;IACE,yBAAyB,EAAE,gCAAgC;EAC7D;;EAEA;IACE,eAAe;IACf,WAAW,EAAE,8BAA8B;EAC7C;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;IACvD,YAAY,EAAE,oCAAoC;EACpD;;EAEA;IACE,cAAc,EAAE,yCAAyC;EAC3D;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".sidebar-list-items {\n  margin: 0;\n  padding: 0;\n}\n.sidebar-list-item {\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: 14px;\n}\n.sidebar-list-icon {\n  width: 15px;\n  height: 15px;\n  margin-right: 10px;\n}\n.user-dropdown {\n  width: 200px !important;\n}\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  background-color: red;\n  width: 100%;\n}\n.sidebar-scroll {\n  height: calc(90vh);\n  overflow: auto;\n  width: 250px;\n}\n.collapse {\n  margin-left: 50px;\n  padding: 0px;\n}\n.setup {\n  margin-left: 0px;\n}\n.setup:hover {\n  color: #2a8981;\n  cursor: pointer;\n}\n.adminActivities {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 18px;\n}\n.hide {\n  display: none !important;\n}\n.sidebar-icon-only .sidebar-list-items {\n  width: 50px;\n}\n.sidebar-icon-only .link-text,\n.sidebar-icon-only .adminActivities {\n  display: none;\n}\n.sidebar-icon-only .sidebar-scroll {\n  width: 50px;\n}\n.sidebar-icon-only .collapse {\n  margin-left: 0px;\n}\n.text-active {\n  color: #2a8981 !important;\n}\n.zindex99 {\n  z-index: 99 !important;\n}\n.right-side {\n  transform: rotateY(180deg);\n}\n\n.left-side {\n  transform: rotateY(0deg);\n}\n.nav-item {\n  font-style: normal;\n  font-size: 15px;\n  color: black !important;\n  font-family: Poppins;\n}\n\n/* styles.css */\n.sidebar-list-items {\n  margin: 0;\n  padding: 0;\n}\n\n.sidebar-list-item {\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-size: 14px;\n}\n\n.sidebar-list-item:hover {\n  background-color: #f0f0f0; /* Update with your preferred hover color */\n  border-radius: 6px 0px 0px 6px; /* Update with your preferred color */\n}\n\n.sidebar-list-item.selected {\n  background-color: rgb(0, 123, 255) !important;\n  color: white !important;\n  border-radius: 6px 0px 0px 6px; /* Update with your preferred color */\n}\n\n.sidebar-list-item .link-text {\n  color: black;\n}\n\n.sidebar-list-item.selected .link-text {\n  color: #2a8981; /* Update with your preferred selected text color */\n}\n\n/* Add other styles as needed */\n/* Sidebar styling */\n.sidebar-open {\n  transform: translateX(0);\n}\n\n.sidebar-closed {\n  transform: translateX(-100%);\n}\n\n/* Toggle button styling */\n.menu-icon-container_v3 {\n  position: fixed;\n  top: 15px;\n  left: 15px;\n  z-index: 100;\n}\n\n/* Styling for selected sidebar item */\n.sidebar-list-item.selected {\n  background-color: #007bff;\n  color: white;\n}\n\n/* Sidebar item hover effect */\n.sidebar-list-item:hover {\n  background-color: #f0f0f0;\n}\n.nav-item {\n  color: black !important; /* Ensure text color is always black */\n}\n\n/* Media query for small screens */\n@media (max-width: 844px) {\n  .icon {\n    position: absolute;\n    top: 5.2rem;\n  }\n  .navbar {\n    background: #000 !important;\n  }\n  .sidebar {\n    width: 75%;\n  }\n}\n\n@media (max-width: 844px) {\n  .sidebar {\n    display: none;\n  }\n\n  .sidebar.open {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 220px;\n    height: auto; /* Adjust height for dropdown */\n    background: #fff;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    transform: translateY(\n      -100%\n    ); /* Initially hide the sidebar above the viewport */\n    transition: transform 0.3s ease;\n    z-index: 1000;\n    transform: translateY(0); /* Slide the sidebar down into view */\n  }\n\n  .menu-icon-container {\n    display: flex;\n    justify-content: flex-end;\n    padding: px;\n    margin-left: -40px;\n    margin-top: 10px;\n  }\n\n  .menu-icon-container .btn {\n    border: none;\n    background-color: transparent;\n  }\n\n  .sidebar-open {\n    background-color: #f8f9fa; /* Light background for visibility */\n    border-right: 1px solid #ddd; /* Add a border for better separation */\n  }\n\n  .sidebar-closed {\n    background-color: #f8f9fa; /* Match open state background */\n  }\n\n  .sidebar-list-item {\n    font-size: 16px;\n    color: #333; /* Text color for visibility */\n  }\n\n  .sidebar-list-item.selected {\n    background-color: #007bff; /* Highlight selected item */\n    color: white; /* Ensure selected text is visible */\n  }\n\n  .nav_link {\n    color: inherit; /* Ensure link text uses parent's color */\n  }\n}\n\n/* Hide menu icon on larger screens */\n@media (min-width: 845px) {\n  .menu-icon-container {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
